import script from "./ButtonPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonPrimary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonPrimary.vue?vue&type=style&index=0&id=fd47663e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aa\\Desktop\\Client-files\\BB\\BB_Web\\bb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd47663e"]])

export default __exports__